import { render, staticRenderFns } from "./HealthUpdate.vue?vue&type=template&id=0d4c6bb6&scoped=true&"
import script from "./HealthUpdate.vue?vue&type=script&lang=js&"
export * from "./HealthUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4c6bb6",
  null
  
)

export default component.exports